import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import type DataMapperLookupTablesStore from "./DataMapperLookupTablesStore";
import { DATA_MAPPER_ROUTE } from "../shared/editorRoutes";

const lookupStore = (rootStore: RootStore) =>
  rootStore.dataMapperLookupTablesViewStore as DataMapperLookupTablesStore;

/**
 * Data Mapper → Lookup Tables: create, edit and delete the open profile's
 * lookup tables (source value → target value), which a Value Lookup step on
 * the Transform screen picks. Gated like the Schema route: the store checks
 * `canUseDataMapper` before calling, and the API refuses viewers regardless.
 */
const dataMapperLookupTablesRoute: RouteType[] = [
  {
    name: DATA_MAPPER_ROUTE.lookupTables,
    path: "/data-mapper/lookup-tables",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Lookup Tables",
        enableRefreshButton: true,
        component: () => import("../shared/DataMapperEditor.Header"),
      },
      body: {
        component: () => import("./DataMapperLookupTables.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["data mapper lookup tables", "lookup table", "value lookup", "code translation"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void lookupStore(rootStore)?.load();
    },
    onExit: ({ rootStore }) => {
      lookupStore(rootStore)?.reset();
    },
  },
];

export default dataMapperLookupTablesRoute;
